import { FC } from 'react';
import { ElementTileTargetIcon } from './ElementTileEmoticonIndicator';
import { ScoreTileWrapperElementSlotProps } from './ScoreTileWrapper';
import { useNavigate } from '@remix-run/react';
import {
  type CalculationScorecardValues,
  ScoreCalculationTooltip,
  scoreCalculationTooltipCalculationScorecardValuesFromScorecard,
} from '../ScoreCalculationTooltip';
import { Scorecard } from '../../../Scorecard';
import clsx from 'clsx';

export type ElementSlotWrapperProps = Omit<ScoreTileWrapperElementSlotProps, 'navigateTo'> &
  Partial<Pick<ScoreTileWrapperElementSlotProps, 'navigateTo'>> & {
    className?: string;
    scorecard: Scorecard;
    readOnly?: boolean;
    disableTooltip?: boolean;
    estateStatusChecklistItems?: CalculationScorecardValues['estateStatusChecklistItems'];
  };

export const ElementSlotWrapper: FC<ElementSlotWrapperProps> = ({ readOnly, ...props }) => {
  const navigate = useNavigate();
  const elementTile = (
    <ElementTileTargetIcon
      className={clsx(props.className, '!z-0')}
      financialElementAbbreviation={props.elementSymbol}
      scoreValue={props.btIsNull ? undefined : props.score}
      targetMin={props.min}
      targetMax={props.max}
      showScoreLine={props.showRange && !props.btIsNull}
      onClick={() => {
        if (readOnly) return;
        props.onClick?.();
        if (props.navigateTo) navigate(props.navigateTo);
      }}
      beachMode={props.beachMode}
    />
  );

  if (props.disableTooltip) {
    return elementTile;
  }

  return (
    <ScoreCalculationTooltip
      className="!pointer-events-none !z-5"
      offset={[0, -210]}
      score={props.score}
      element={props.elementSymbol}
      beachMode={props.beachMode}
      calculationScorecardValues={{
        ...scoreCalculationTooltipCalculationScorecardValuesFromScorecard(props.scorecard),
        estateStatusChecklistItems: props.estateStatusChecklistItems,
      }}
    >
      {elementTile}
    </ScoreCalculationTooltip>
  );
};
